(function () {
  'use strict';

  var syncTimer = 0;
  var syncRequest = null;
  var syncRetries = 0;
  var observedCount = null;

  function cartCount() {
    var values = Array.prototype.map.call(
      document.querySelectorAll('a[href="/cart"], [data-cart-count]'),
      function (node) {
        var match = String(node.textContent || '').trim().match(/^\d+/);
        return match ? parseInt(match[0], 10) : NaN;
      }
    ).filter(function (value) { return Number.isFinite(value); });

    return values.length ? Math.max.apply(null, values) : 0;
  }

  function quantityFromDrawer(scope) {
    var inputs = scope.querySelectorAll('[data-cart-item] [data-quantity-value]');
    if (!inputs.length) return scope.querySelectorAll('[data-cart-item]').length;
    return Array.prototype.reduce.call(inputs, function (total, input) {
      var quantity = parseInt(input.value, 10);
      return total + (Number.isFinite(quantity) ? quantity : 0);
    }, 0);
  }

  function syncDrawer() {
    var drawer = document.querySelector('#t4s-mini_cart');
    if (!drawer || syncRequest) return syncRequest || Promise.resolve();

    var rootPath = window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root
      : '/';
    var url = rootPath + 'cart?section_id=mini_cart&lf_sync=' + Date.now();

    syncRequest = window.fetch(url, {
      credentials: 'same-origin',
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart section refresh failed');
      return response.text();
    }).then(function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var incomingSection = parsed.querySelector('#shopify-section-mini_cart') || parsed.body;
      var incomingWrap = incomingSection && incomingSection.querySelector('.t4s-drawer__wrap');
      var currentWrap = drawer.querySelector('.t4s-drawer__wrap');
      if (!currentWrap) return;
      if (!incomingWrap) throw new Error('Cart section markup missing');

      var importedWrap = document.importNode(incomingWrap, true);
      currentWrap.replaceWith(importedWrap);

      var count = quantityFromDrawer(importedWrap);
      drawer.setAttribute('data-ccount', String(count));
      observedCount = count;
      syncRetries = 0;

      importedWrap.dispatchEvent(new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: { sectionId: 'mini_cart' }
      }));
      document.dispatchEvent(new CustomEvent('lf:cart-refreshed', {
        detail: { count: count }
      }));
    }).catch(function (error) {
      if (syncRetries < 2) {
        syncRetries += 1;
        window.setTimeout(function () {
          if (!syncRequest) syncDrawer();
        }, 300 * syncRetries);
        return;
      }
      syncRetries = 0;
      console.warn('[LA FORTE] Cart drawer sync:', error);
    }).finally(function () {
      syncRequest = null;
    });

    return syncRequest;
  }

  function queueSync(delay) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncDrawer, typeof delay === 'number' ? delay : 140);
  }

  function checkCount() {
    var current = cartCount();
    if (observedCount === null) {
      observedCount = current;
      return;
    }
    if (current !== observedCount) {
      observedCount = current;
      queueSync(120);
    }
  }

  function boot() {
    if (document.documentElement.dataset.lfCartSyncReady === 'true') return;
    document.documentElement.dataset.lfCartSyncReady = 'true';
    observedCount = cartCount();

    var drawer = document.querySelector('#t4s-mini_cart');
    if (drawer && drawer.querySelector('.t4s-drawer__wrap') && quantityFromDrawer(drawer) !== observedCount) queueSync(40);

    var observer = new MutationObserver(checkCount);
    document.querySelectorAll('a[href="/cart"], [data-cart-count]').forEach(function (node) {
      observer.observe(node, { childList: true, subtree: true, characterData: true });
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest && event.target.closest('form');
      if (!form) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1 && !form.matches('[data-type="add-to-cart-form"]')) return;
      [350, 800, 1500, 2400].forEach(function (delay) {
        window.setTimeout(checkCount, delay);
      });
    }, true);

    document.addEventListener('cart:updated', function () { queueSync(100); });
    document.addEventListener('cart:refresh', function () { queueSync(100); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
